<template>
  <div class="project-card" @click="goToProject">
    <svg class="rounded-top">
      <defs>
        <filter id="Path_184" x="0" y="0" width="244.272" height="138.253" filterUnits="userSpaceOnUse">
          <feOffset dx="15" dy="15" input="SourceAlpha"/>
          <feGaussianBlur stdDeviation="20" result="blur"/>
          <feFlood flood-color="#647991" flood-opacity="0.251"/>
          <feComposite operator="in" in2="blur"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <g transform="matrix(1, 0, 0, 1, 0, 0)">
        <g id="Path_184-2" data-name="Path 184" transform="translate(0 25)" fill="#fcfcff">
          <path d="M 71.15789794921875 -4.246612548828125 C 48.40359878540039 -4.246612548828125 24.63330078125 -4.412353992462158 0.5000085234642029 -4.739255905151367 L 0.5000085234642029 -13.93001270294189 C 0.5000085234642029 -18.10412216186523 3.867208480834961 -21.4999942779541 8.006045341491699 -21.4999942779541 L 94.27928161621094 -21.4999942779541 C 97.26011657714844 -21.4999942779541 99.57330322265625 -20.74444961547852 101.5589904785156 -19.12226676940918 C 103.3429718017578 -17.66486740112305 104.6385726928711 -15.69928550720215 106.0102462768555 -13.61828517913818 C 107.5732421875 -11.24703121185303 109.1894607543945 -8.79503059387207 111.6664810180664 -6.916412830352783 C 113.0792846679688 -5.844922065734863 114.6702194213867 -5.049966335296631 116.4646224975586 -4.524078845977783 C 107.7130432128906 -4.391334533691406 91.9329833984375 -4.246612548828125 71.15789794921875 -4.246612548828125 Z" stroke="none"/>
          <path id="border"  d="M 8.00604248046875 -20.9999942779541 C 4.142898559570312 -20.9999942779541 0.9999847412109375 -17.82841300964355 0.9999847412109375 -13.93001270294189 L 0.9999847412109375 -5.232561111450195 C 24.96121978759766 -4.910106658935547 48.56074523925781 -4.746612548828125 71.15788269042969 -4.746612548828125 C 90.10337829589844 -4.746612548828125 104.7992248535156 -4.86480712890625 113.8606185913086 -4.985462188720703 C 109.8055648803711 -6.952131271362305 107.6118316650391 -10.27996253967285 105.5927734375 -13.34312152862549 C 102.8846282958984 -17.45170402526855 100.5457916259766 -20.9999942779541 94.27928161621094 -20.9999942779541 L 8.00604248046875 -20.9999942779541 M 8.00604248046875 -21.9999942779541 C 8.00604248046875 -21.9999942779541 79.83232116699219 -21.9999942779541 94.27928161621094 -21.9999942779541 C 108.7262649536133 -21.9999942779541 104.2050476074219 -4.246011734008789 122.423828125 -4.246011734008789 C 130.7917938232422 -4.246011734008789 110.2164688110352 -3.746610641479492 71.15788269042969 -3.746610641479492 C 51.62502288818359 -3.746610641479492 27.47501373291016 -3.871416091918945 -1.52587890625e-05 -4.246011734008789 L -1.52587890625e-05 -13.93001270294189 C -1.52587890625e-05 -18.38694000244141 3.584426879882812 -21.9999942779541 8.00604248046875 -21.9999942779541 Z" stroke="none" fill="#fcfcff"/>
        </g>
        <rect x="1" y="19" width="10" height="3" fill="#fcfcff"></rect>
        <rect x="10" y="19" width="106" height="4" fill="#fcfcff" rx="20" ry="20"></rect>
      </g>

    </svg>
    <div class="project-card-wrapper">
      <div class="project-card-header">
        <div class="project-card-date">
          {{ project.creationTimestamp | formatDate }}
        </div>
        <project-card-status :status="project.status"></project-card-status>
        <project-action-menu :project="project"></project-action-menu>
      </div>
      <div class="project-card-body">
        <div class="project-card-name">
          {{ project.name }}
        </div>
        <div class="project-card-content">
          <div class="project-card-description">
            {{project.description}}
          </div>
          <div class="project-card-description">
            <input-container
              v-for="(field,i) in relevantFields"
              ref="input"
              :key="field.name"
              v-model="relevantFields[i]"
              :readOnly="true"
              class="project-description-item"
            />
          </div>
          <!--<div class="project-card-link">
            <div class="project-card-link-text">{{ $t("see_details") }}</div>
            <div class="project-card-link-icon"></div>
          </div>-->
        </div>
        <div class="project-card-footer" :class="{ open: expanded }">
          <div class="project-card-trials">
            <div class="project-card-trials-header" @click.stop="expanded=!expanded">
              <div class="project-card-trials-title">{{project.trials.length}} {{$t('trials')}}</div>
              <div :class="['toggle-button', {'open': expanded}]"></div>
            </div>
            <project-card-trials-steps :trialList="project.trials">></project-card-trials-steps>
          </div>
          <project-card-trials-list :projectId="project.id" :trialList="project.trials"></project-card-trials-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectActionMenu from '@/components/project/ProjectActionMenu'
import ProjectCardTrialsSteps from '@/components/project/ProjectCardTrialsSteps'
import ProjectCardStatus from '@/components/project/ProjectCardStatus'
import ProjectCardTrialsList from '@/components/project/ProjectCardTrialsList'
import InputContainer from '@/components/inputs/InputContainer'
import projectData from '@/mixins/projectData'

export default {
  name: 'ProjectCard',
  props: ['project'],
  mixins: [projectData],
  components: {ProjectActionMenu, ProjectCardTrialsSteps, ProjectCardStatus, ProjectCardTrialsList, InputContainer},
  data () {
    return {
      expanded: false
    }
  },
  computed: {
    // descriptionFields() {
    //   if (this.projectFields && this.project.fieldList) {
    //     let tmp = this.mergeConfigData({fieldList:this.projectFields}, this.project)
    //     return tmp.fieldList.slice(0,2)
    //   }
    //   return []
    // }
  },
  methods: {
    goToTrial(projectId, trialId) {
      this.$router.push({path: `/project/${projectId}/trial/${trialId}/results`})
    },
    goToProject(evt){
      // if(evt.currentTarget == this.$el){
        this.$router.push({path: `/project/${this.project.id}`})
      // }
    }
  }
}
</script>

<style lang="stylus">
.project-card
  //box-shadow: 15px 15px 40px rgba($lynch, 0.25)
  display: flex
  flex-direction: column
  height: $card-height
  position: relative
  transition: transform 0.15s ease-in-out
  overflow hidden
  //&:before
  //  background-color: $titan-white
  //  border-radius: 10px 10px 0 0
  //  content: ""
  //  height: 20px
  //  left: 0
  //  position: absolute
  //  top: -20px
  //  width: 40%

  &:hover
    //border 1px solid $heather
    transform: translateY(-3px)
    cursor pointer
    .project-card-wrapper
      border 1px solid $heather
    svg
      #border
        fill $heather

    //box-shadow: 15px 15px 40px rgba($lynch, 0.75)
  .rounded-top
    position absolute
    left 0px
    top 0px
    height 22px
  .project-card-wrapper
    padding: 15px
    background-color: $titan-white
    border-radius: 0 5px 5px 5px
    height 100%
    margin-top 20px
    border 1px solid $titan-white
  .project-card-header
    align-items: center
    display: flex
    flex: 0 0 20px
    margin-bottom: 5px
    width: 100%

    .project-card-date
      color: rgba($cloud-burst, 0.5)
      m-font-size(12, 14)

  .project-card-body
    display: flex
    flex: 1 1 50%
    flex-direction: column
    position: relative
    min-height 270px
    max-height 270px
    .project-card-name
      m-font-size(16, 20)
      font-weight: $fw-bold
      margin-bottom: 5px

    .project-card-content
      overflow: hidden
      padding-bottom: $footer-height + 10
      max-height 270px

      .project-card-description
        m-font-size(12, 18)
        flex: 1 1 0%
        font-weight: $fw-light
        margin-bottom: 10px
        margin-top: 10px

        .value-input-component-container
          .input-component
            padding 0px
            label
              cursor pointer

      .project-description-item
        &:not(:last-child)
          margin-bottom: 10px

      .project-card-link
        align-items: center
        display: flex
        margin: 5px 0

        &:hover
          .project-card-link-text
            &:after
              width: 100%

          .project-card-link-icon
            transform: translateX(4px)

        .project-card-link-text
          color: $cloud-burst
          position: relative
          text-decoration: none
          m-font-size(12, 14)
          cursor: pointer
          font-weight: $fw-semi-bold

          &:after
            background-color: $cloud-burst
            bottom: -2px
            content: ""
            height: 2px
            left: 0
            position: absolute
            transition: width 0.25s ease-in-out
            width: 0

      .project-card-link-icon
        m-icon("arrow-right-cloud-burst", 8 6)
        margin-left: 5px
        transition: transform 0.25s ease-in-out

  .project-card-footer
    $footer-height-ratio = 1.5
    background-color: $titan-white
    border-radius: 0 0 5px 5px
    bottom: -15px
    display: flex
    flex-direction: column
    height: $footer-height
    left: -15px
    overflow: hidden
    position: absolute
    transition: height 0.25s ease-in-out
    width: calc(100% + 30px)

    &.open
      height: (($card-height - $footer-height) / $footer-height-ratio)

      &:before
        background: rgb(250, 250, 251)
        background: linear-gradient(180deg, rgba(250, 250, 251, 0) 0, rgba(250, 250, 251, 1) 100%)
        content: ""
        display: block
        height: 30px
        width: 100%

    .project-card-trials
      border-top: 1px solid $mystic
      padding: 10px 15px 15px

      .project-card-trials-header
        cursor: pointer
        display: flex

        .project-card-trials-title
          m-font-size(12, 14)
          margin-bottom: 10px

        .toggle-button
          margin-left: auto
          m-icon("toggle-panel-caret", 15)
          transform: rotate(0)
          transition: all 0.3s

          &.open
            transform: rotate(180deg)

    .project-card-expanded-trials
      background-color: $mystic
      flex: 0 0 (($card-height - $footer-height) / $footer-height-ratio) - $footer-height
      height: (($card-height - $footer-height) / $footer-height-ratio) - $footer-height
      position: relative

      &:before
        background: $lynch
        background: linear-gradient(180deg, rgba($lynch, 0.25) 0, rgba(#fff, 0) 30%)
        content: ""
        display: block
        height: 20px
        left: 0
        position: absolute
        top: 0
        width: 100%

      .trial
        position: relative
</style>